import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormControl, InputGroup } from "react-bootstrap";

class TargetCard extends React.Component {
  static get displayName() {
    return "TargetCard";
  }

  static get propTypes() {
    return {
      id: PropTypes.number,
      isSelectable: PropTypes.bool,
      details: PropTypes.object,
      duration: PropTypes.number,
      onClick: PropTypes.func,
      onChangeDuration: PropTypes.func,
      selectedId: PropTypes.number,
      showDuration: PropTypes.bool,
      size: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      isSelectable: true,
    };
  }

  constructor(props) {
    super(props);

    this._onChangeDuration = this._onChangeDuration.bind(this);
  }

  _renderIcon(targetDetails, className) {
    const type = targetDetails.type;
    if (!type) {
      return null;
    }
    if (type.startsWith("image") || type === "application") {
      return <img className={className} src={targetDetails.icon} />;
    } else if (type.startsWith("video")) {
      return (
        <video preload={false} className={className} controls={true}>
          <source src={targetDetails.icon} />
        </video>
      );
    }
    return null;
  }

  _isTargetInactive() {
    const { id, selectedId } = this.props;
    return selectedId && String(selectedId) !== String(id);
  }

  _isTargetSelected() {
    const { id, selectedId, isSelectable } = this.props;
    return isSelectable && selectedId && String(selectedId) === String(id);
  }

  _onChangeDuration(e) {
    const duration = parseInt(e.currentTarget.value, 10) * 1000;
    this.props.onChangeDuration(duration);
  }

  render() {
    const {
      details,
      duration,
      id,
      isSelectable,
      onClick,
      showDuration,
      size = "small",
    } = this.props;

    const classes = classNames(
      "app-box",
      `app-box-${size}`,
      "box",
      "box-widget",
      "widget-user",
      {
        selected: this._isTargetSelected(),
        "no-hover": !isSelectable,
        inactive: this._isTargetInactive(),
      },
    );

    const durationSeconds = (duration || details.duration || 0) / 1000;

    return (
      <div key={id} className={classes}>
        <div id={"app-icon-" + id} onClick={onClick}>
          <div className="widget-user-header">
            {this._renderIcon(details, "app-icon")}
          </div>
          <div className="box-footer">{details.name}</div>
        </div>
        {showDuration && details.type && !details.type.startsWith("video") && (
          <div className="user-content-overlay">
            <InputGroup>
              <FormControl
                type="text"
                name="duration"
                className="form-control edit-duration-value"
                key="duration"
                value={durationSeconds}
                onChange={this._onChangeDuration}
                disabled={!isSelectable}
              />
              <InputGroup.Append>
                <InputGroup.Text>seconds</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </div>
        )}
      </div>
    );
  }
}

module.exports = TargetCard;
